"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSpring = require("react-spring");

var _reactUseGesture = require("react-use-gesture");

var _CarouselContextProvider = require("./CarouselContextProvider");

var _CarouselModule = _interopRequireDefault(require("./Carousel.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // https://tsh.io/blog/react-state-management-react-hooks-vs-redux/


var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      containerWidth = _ref.containerWidth;
  var refContainer = (0, _react.useRef)(0);
  var setRefs = (0, _react.useRef)(0);

  var _useContext = (0, _react.useContext)(_CarouselContextProvider.CarouselContext),
      _useContext2 = _slicedToArray(_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1];

  (0, _react.useEffect)(function () {
    dispatch({
      type: "SET_TOTAL_COUNT",
      payload: children.length
    });
  }, [children]);
  (0, _react.useEffect)(function () {
    setSwipe();
  }, [state.cursorIndex]);

  var _useSprings = (0, _reactSpring.useSprings)(children.length, function (i) {
    return {
      x: i * containerWidth,
      display: 'block',
      pointerEvents: 'none'
    };
  }),
      _useSprings2 = _slicedToArray(_useSprings, 2),
      springs = _useSprings2[0],
      set = _useSprings2[1];

  var bind = (0, _reactUseGesture.useGesture)({
    onDrag: function onDrag(_ref2) {
      var down = _ref2.down,
          _ref2$movement = _slicedToArray(_ref2.movement, 1),
          mx = _ref2$movement[0],
          _ref2$direction = _slicedToArray(_ref2.direction, 1),
          xDir = _ref2$direction[0],
          distance = _ref2.distance,
          cancel = _ref2.cancel; //в крайних положениях не дает свайпить дальше


      if (children.length - 1 === state.cursorIndex && xDir < 0 || state.cursorIndex === 0 && xDir > 0) {
        cancel();
      }

      if (down && distance > containerWidth / 2) {
        dispatch({
          type: "SET_CURRENT_INDEX",
          payload: xDir > 0 ? -1 : 1
        });
        cancel();
      }

      setSwipe(down, mx, distance);
    },
    onDragStart: function onDragStart() {
      set(function (i) {
        return {
          pointerEvents: 'none'
        };
      });
    },
    onMouseUp: function onMouseUp(prop) {
      set(function (i) {
        return {
          pointerEvents: 'auto'
        };
      });
    },
    onTouchEnd: function onTouchEnd(prop) {
      set(function (i) {
        return {
          pointerEvents: 'auto'
        };
      });
    }
  });

  var setSwipe = function setSwipe(down, mx, distance) {
    set(function (i) {
      if (i < state.cursorIndex - 1 || i > state.cursorIndex + 1) return {
        display: 'none'
      };
      var x = (i - state.cursorIndex) * containerWidth + (down ? mx : 0);
      return {
        x: x,
        display: 'block',
        pointerEvents: distance > 0.5 ? 'none' : 'auto'
      };
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _CarouselModule["default"].carousel,
    ref: refContainer,
    style: {
      height: setRefs.current
    }
  }, springs.map(function (_ref3, i) {
    var x = _ref3.x,
        display = _ref3.display,
        pointerEvents = _ref3.pointerEvents,
        userSelect = _ref3.userSelect;
    return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, _extends({}, bind(), {
      key: i,
      style: {
        display: display,
        transform: x.interpolate(function (g) {
          return "translate3d(".concat(g, "px, 0, 0)");
        })
      },
      className: _CarouselModule["default"].wrapper
    }), /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
      className: _CarouselModule["default"].item,
      style: {
        pointerEvents: pointerEvents,
        userSelect: userSelect
      }
    }, /*#__PURE__*/_react["default"].cloneElement(children[i], {
      ref: function ref(node) {
        if (node !== null && node !== void 0 && node.offsetHeight) {
          setRefs.current = Math.max(setRefs.current, node === null || node === void 0 ? void 0 : node.offsetHeight);
        }

        return node;
      }
    })));
  }));
};

var _default = Carousel;
exports["default"] = _default;
Carousel.displayName = 'Carousel';
Carousel.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired
};